var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatBubbleToggle = function SvgChatBubbleToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 4.6h11.8a3.6 3.6 0 0 1 3.6 3.6v6.2a3.6 3.6 0 0 1-3.6 3.6h-4.15l-4.7 3.15V18H6.1a3.6 3.6 0 0 1-3.6-3.6V8.2a3.6 3.6 0 0 1 3.6-3.6zm0 1.55c-1.13 0-2.05.92-2.05 2.05v6.2c0 1.13.92 2.05 2.05 2.05h4.35v1.85l2.85-1.91h4.4c1.13 0 2.05-.92 2.05-2.05V8.2c0-1.13-.92-2.05-2.05-2.05H6.1z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 9.4h9.2a2.6 2.6 0 0 1 0 5.2H7.4a2.6 2.6 0 0 1 0-5.2zm1.15 1.2a1.4 1.4 0 0 0 0 2.8h6.9a1.4 1.4 0 0 0 0-2.8h-6.9z",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.35,
    cy: 12,
    r: 1.25
  })));
};
export default SvgChatBubbleToggle;